<template>
    <div></div>
</template>
<script>

    export default {
        props: ['value'],
        data () {
            return {
                /*
                config: {
                    imageUploadURL: '/upload_image',
                    events: {
                        'froalaEditor.initialized': function () {
                            console.log('initialized')
                        }
                    },
                    useClasses: false,
                    htmlAllowedTags: ['.*'],
                    htmlRemoveTags: [''],
                    fullPage: true,
                    lineBreakerTags: [''],
                    linkAlwaysBlank: true,
                    toolbarButtons: {
                        'moreText': {
                            'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                        },
                        'moreParagraph': {
                            'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                        },
                        'moreRich': {
                            'buttons': ['insertLink', 'insertImage', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters']
                        },
                        'moreMisc': {
                            'buttons': ['undo', 'redo', 'fullscreen', 'html']
                        }
                    }
                },
                */
                modalClass: "",
                resource: {},
                locale: null,
                locales: null,
                localesLoaded: null
            }
        },
        mounted: function(){
            this.locale = this.$store.state.scope.locales[0].id,
            this.locales = this.$store.state.scope.locales

            self = this;
            document.onkeydown=function(event){
                if((event.ctrlKey || event.metaKey) && event.which == 83) {
                    event.preventDefault();
                    self.submit()
                    return false;
                }
            }

            if( this.$route.meta.action == "edit" ){

                this.get();

            }else{

                setTimeout(function(){
                    self.modalClass = "show";
                    self.resourceLoaded();
                }, 50);

            }
        },
        methods:{
            copy:function(original) {
                return JSON.parse(JSON.stringify(original));
            },
            setTranslationsTo: function(obj, fields){

                let trans = obj.translations ? this.copy(obj.translations) : null;
                if( trans && !trans[0] ){ return false; }

                let translations = {};
                for (var i=0 ; i<this.locales.length ; i++ ) {
                    let locale = this.locales[i];
                    translations[locale.id] = {};
                    let founded = false;
                    if( obj.translations ) {
                        for (var a = 0; a < obj.translations.length; a++) {
                            let item = obj.translations[a];
                            if (item.locale == locale.id) {
                                for (var x = 0; x < fields.length; x++) {
                                    translations[locale.id][fields[x]] = item[fields[x]];
                                }
                                founded = true;
                            }
                        }
                    }
                    if( !founded ){
                        for (var x=0 ; x<fields.length ; x++ ) {
                            translations[locale.id][fields[x]] = "";
                        }
                    }
                }
                obj.translations = translations;

                if( this.$route.meta.action == "new" ){ this.localesLoaded = true; }
            },
            setTranslations: function(fields){
                this.setTranslationsTo(this.resource, fields);
                this.localesLoaded = true;
            },
            resourceLoaded: function(){
                this.localesLoaded = true;
            },
            get: function(){
                this.getResource().api.get(this.$route.params.id).then((response) => {
                    this.resource = response.data
                    console.log('RESOURCE', response.data)
                    var self = this;
                    this.resourceLoaded();
                    setTimeout(function(){
                        self.modalClass = "show";
                    }, 50);
                })
            },
            beforeUpdate: function(){
                return true;
            },
            submit: function(){
                if( !this.beforeUpdate() ){
                    return false;
                }

                if( this.$route.meta.action == "edit" ){

                    this.getResource().api.update(this.$route.params.id, this.resource).then((response) => {
                        this.$emit('refresh', this);
                        this.back();
                    })

                }else{

                    this.getResource().api.create(this.resource).then((response) => {
                        this.$emit('refresh', this);
                        this.back();
                    })
                }

            },
            back: function(){
                self = this
                if( this.modalClass == "show" ){
                    this.modalClass = "hide";
                    setTimeout(function(){
                        let name = self.$route.name.replace('-edit', '').replace('-new', '')
                            //name = self.$route.meta.parent ? self.$route.meta.parent : name
                        self.$router.push({name: name});
                    }, 500);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Edit.vue